import { TbTag } from 'react-icons/tb';
import type { IconProps } from './IconBase';
import { IconBase } from './IconBase';

export const TagIcon = (props: IconProps) => {
  return <IconBase icon={TbTag} {...props} />;
};
